import React from 'react'
import { UnderlineTabs } from 'src/components/app-ui'

const TABS = [
  { value: 'personal', label: 'My paths' },
  { value: 'shared', label: 'Shared with me' },
]

/** Switches between the user's own paths and paths shared with them. */
const ViewTabs = ({ value, onChange }) => (
  <UnderlineTabs tabs={TABS} value={value} onChange={onChange} />
)

export default ViewTabs
